// Copyright (c) Move Closer 2022.

import { VueConstructor } from 'vue'

import { CreationAddon, ImageAddon } from './addons'
import { PossibleAddon, PossibleAddons } from '../Hero.contracts'

/**
 * Maps `AdoonType` to applicable `VueConstructor`
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const heroModuleAddonsFormRegistry: Record<PossibleAddon, VueConstructor> = {
  [PossibleAddons.Creations]: CreationAddon,
  [PossibleAddons.Image]: ImageAddon
}
